// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"style_menu-item__dMsS4","menu-item--icon":"style_menu-item--icon__pJwYr","menu-item--login":"style_menu-item--login__zWU8h"};